import jquery from 'jquery';
window.$ = window.jQuery = window.$ || jquery;

import src from 'select2?raw';
new Function('module', 'require', 'window', 'jQuery', src)(
    {}, () => window.jQuery, window, window.jQuery
);
